module.exports = __webpack_public_path__ + "static/media/space-1.1558e2c8.png";